import data from './data'
import widget from './widget'

export default function (_this) {
  return {
    widget: widget(_this),
    data: data(_this)
  }
}
